import { render, staticRenderFns } from "./adminWorkPoolList.vue?vue&type=template&id=87065c5a&scoped=true"
import script from "./adminWorkPoolList.vue?vue&type=script&lang=js"
export * from "./adminWorkPoolList.vue?vue&type=script&lang=js"
import style0 from "./adminWorkPoolList.vue?vue&type=style&index=0&id=87065c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87065c5a",
  null
  
)

export default component.exports